export default __webpack_public_path__ + "static/media/party.24fb0295.png";